import { useEffect } from 'react';
import { Outlet, useLocation, useNavigate } from 'react-router-dom';

import { useAuth0 } from '@auth0/auth0-react';

import usePageRoutes from 'hooks/usePageRoutes';

import type { FunctionComponent } from './types';

const VerifyEmailGuard: FunctionComponent = () => {
    const { isLoading, user = {} } = useAuth0();
    const navigate = useNavigate();
    const location = useLocation();
    const { verifyEmailPage } = usePageRoutes();

    const { email_verified: isEmailVerified } = user;
    const isOnVerifyEmailPage = location.pathname === verifyEmailPage;

    useEffect(() => {
        if (!isEmailVerified && !isLoading && !isOnVerifyEmailPage) {
            navigate(verifyEmailPage);
        }
    }, [isEmailVerified, isLoading, verifyEmailPage, navigate, isOnVerifyEmailPage]);

    if (isLoading || !user) {
        return null;
    }

    if (isOnVerifyEmailPage || user.email_verified) {
        return <Outlet />;
    }

    return null;
};

export default VerifyEmailGuard;
